import React, { useEffect, useState } from "react";
import ShowAll from "./components/ShowAll/ShowAll";
import { useDispatch, useSelector } from "react-redux";
import {
  selectMemberships,
  setActiveOrganization,
} from "../../redux/authSlice";
import { switchOrganization } from "../../services/organizationService";

interface CustomProps {
  setToggle: any;
  toggle: any;
}

const Team = (_props: CustomProps) => {
  const [tabValue] = useState<string>("Show All");
  const dispatch = useDispatch();
  const memberships = useSelector(selectMemberships);

  useEffect(() => {
    // Prefer Home Tatva org context for this screen
    const homeTatva = (memberships || []).find(
      (m) =>
        m.organization?.slug === "home-tatva" ||
        m.organization?.name?.toLowerCase().includes("home tatva")
    );
    if (!homeTatva) return;
    (async () => {
      try {
        const res = await switchOrganization(String(homeTatva.organizationId));
        dispatch(
          setActiveOrganization({
            activeOrganizationId: String(homeTatva.organizationId),
            accessToken: res?.data?.accessToken,
          })
        );
      } catch (_) {
        dispatch(
          setActiveOrganization({
            activeOrganizationId: String(homeTatva.organizationId),
          })
        );
      }
    })();
  }, []);

  function getContent() {
    switch (tabValue) {
      case "Show All":
        return <ShowAll />;
      default:
        return null;
    }
  }

  return (
    <div className="flex h-[calc(100vh-68px)] max-h-[calc(100vh-68px)] flex-col overflow-hidden bg-white p-4 sm:p-5 lg:p-6">
      {getContent()}
    </div>
  );
};

export default Team;
